/** Three-dot "advisor is typing" bubble (CSS-only; replaces the source Lottie animation). */
export function TypingIndicator() {
  return (
    <div className="flex w-max items-center gap-1 rounded-xl bg-purple-light/10 px-4 py-3">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="size-1.5 animate-bounce rounded-full bg-purple-light/70"
          style={{ animationDelay: `${i * 0.15}s` }}
        />
      ))}
    </div>
  )
}
